import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { sizes, variantClasses } from '../../styles/button';

export type ButtonVariant = 'main' | 'secondary' | 'add' | 'delete';

type GenericButtonProps = {
	label?: string;
	onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void | Promise<void>;
	size?: 'sm' | 'md' | 'lg';
	variant: ButtonVariant;
	icon?: IconProp;
	invert?: boolean;
	disabled?: boolean;
	fullWidth?: boolean;
	type?: 'button' | 'submit' | 'reset';
	hideIcon?: boolean;
	forceShowLabel?: boolean;
};

const GenericButton: React.FC<GenericButtonProps> = ({
	label,
	onClick,
	size = 'md',
	variant,
	icon,
	invert = false,
	disabled = false,
	fullWidth = false,
	type = 'button',
	hideIcon = false,
	forceShowLabel = false,
}) => {
	const iconOnly = size === 'sm' && icon && !forceShowLabel;

	return (
		<button
			type={type}
			onClick={onClick}
			disabled={disabled}
			className={`
				${sizes[size]}
				${variantClasses[variant]}
				flex items-center
				${iconOnly ? 'justify-center rounded-full p-0 w-8 h-8' : 'gap-2'}
				${fullWidth && !iconOnly ? 'w-full justify-center' : ''}
				${disabled ? 'opacity-20 pointer-events-none' : ''}
			`}
		>
			{/* Label à gauche si invert */}
			{!iconOnly && invert && label && <span>{label}</span>}

			{/* Icon si showIcon */}
			{icon && !hideIcon && (
				<FontAwesomeIcon icon={icon} className="w-4 h-4 inline-block" />
			)}
			{/* Label à droite si non invert */}
			{!iconOnly && !invert && label && <span>{label}</span>}
		</button>
	);
};

export default GenericButton;
